import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cybersecurity',
  templateUrl: './cybersecurity.component.html',
  styleUrls: ['./cybersecurity.component.css']
})
export class CybersecurityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
